/* eslint-disable */
import React from 'react';
import Rive from '@rive-app/react-canvas';
const Loader = props => (
	<div className="showRiveLoader">
		<Rive src="/rive_loader.riv" style={{width:'400px', height: "400px"}}/>
	</div>
			
);

export default Loader;
